import { render, staticRenderFns } from "./InicioView.vue?vue&type=template&id=48ae78b0&"
import script from "./inicio.js?vue&type=script&lang=js&"
export * from "./inicio.js?vue&type=script&lang=js&"
import style0 from "./InicioView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports